<div class="content">
  <div class="default-card">

    <h2 class="card-title">JSPrintManager Baskı Testi (v8 Uyumlu)</h2>

    <div
      [ngClass]="{
        'status-box': true,
        'status-success': wsStatusType === 'success',
        'status-error': wsStatusType === 'error',
        'status-warning': wsStatusType === 'warning'
      }"
    >
      <p>
        <span class="font-bold">Durum:</span> {{ wsStatusMessage }}
      </p>
    </div>

    <dx-form id="form" [formData]="formDto" [labelMode]="labelMode" [labelLocation]="labelLocation">
      <dxi-item itemType="group" [colSpan]="1">

        <dxi-item
          dataField="printType"
          [label]="{ text: 'Baskı Tipi' }"
          editorType="dxSelectBox"
          [editorOptions]="{
              items: yaziciTipiList,
              valueExpr: 'id',
              displayExpr: 'name',
              placeholder: 'Seçiniz...',
              searchEnabled: true,
              showClearButton: true
          }"
        ></dxi-item>

        <dxi-item
          dataField="printerName"
          [label]="{ text: 'Yazıcı Adı (Yerel/Ağ)' }"
          editorType="dxSelectBox"
          [editorOptions]="{
              items: yaziciList,
              valueExpr: 'name',
              displayExpr: 'name',
              placeholder: 'Yazıcı seçiniz',
              searchEnabled: true,
              showClearButton: true,
              disabled: !isJspmConnected() || yaziciList.length === 0
          }"
        ></dxi-item>

        <dxi-item
          itemType="button"
          [buttonOptions]="{
              text: 'Yazıcıya Gönder',
              type: 'success',
              useSubmitBehavior: true,
              onClick: submitForm.bind(this),
              disabled: !isJspmConnected()
          }"
        ></dxi-item>

      </dxi-item>
    </dx-form>

  </div>
</div>
